import { Box, Button, TextField, Typography } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { InputKit } from '../UI';
import { AuthService } from '../../Service/AuthService';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { createNotification } from '../../store/notifications/notification-slice';
import { zodResolver } from '@hookform/resolvers/zod';
import { securitySchema } from './validations';
export interface IFormInput {
  password: string;
  newPassword: string;
  confirmNewPassword: string;
}
const Security = () => {
  const methods = useForm<IFormInput>({
    resolver: zodResolver(securitySchema),
  });
  const { handleSubmit, watch, setError } = methods;
  const authUser = useAppSelector(state => state.user.user);
  const appDispatch = useAppDispatch();
  const onSubmit = async (data: IFormInput) => {
    try {
      const response = await AuthService.updatePassword(data);

      appDispatch(
        createNotification({
          message: 'Password updated successfully!',
          type: 'success',
        })
      );
    } catch (error: any) {
      if (error.message === 'Invalid password!') {
        setError('password', {
          type: 'required',
          message: 'Password is incorrect!',
        });
      } else {
        appDispatch(
          createNotification({
            message: 'Something went wrong!',
            type: 'error',
          })
        );
      }
    }
  };

  const forgetPassword = async () => {
    try {
      await AuthService.forgotPassword(authUser?.email!);
      appDispatch(
        createNotification({
          message: 'Reset password email sent!',
          type: 'success',
        })
      );
    } catch (error: any) {
      appDispatch(
        createNotification({
          message: 'Something went wrong!',
          type: 'error',
        })
      );
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={'24px'}
          maxWidth={'416px'}
          width={'100%'}
        >
          <InputKit
            name={'password'}
            type={'password'}
            placeholder='Current Password'
          />
          <InputKit
            name={'newPassword'}
            type={'password'}
            placeholder='New password'
          />

          <InputKit
            name={'confirmNewPassword'}
            type={'password'}
            placeholder='Confirm password'
          />
          <Typography
            sx={{
              textDecoration: 'none',
              color: '#3293DB',
              marginTop: '-18px',
              textAlign: 'right',
              cursor: 'pointer',
            }}
            onClick={forgetPassword}
          >
            Forgot password?
          </Typography>
          <Box
            display={'flex'}
            justifyContent={'flex-end'}
            mt={'8px'}
            gap={'12px'}
          >
            <Button
              sx={{
                fontSize: '14px',
                color: '#655C68',
                border: '1px solid #655C68',
                '&:hover': {
                  border: '1px solid #655C68',
                },
              }}
              variant='outlined'
            >
              Cancel
            </Button>
            <Button
              sx={{
                background: '#3293DB',
                color: '#fff',
                fontSize: '14px',
              }}
              type='submit'
              variant='contained'
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default Security;
